import React from 'react';
import { CQ_CODE_CITY, CQ_CODE_SUBURB } from '@/common/components/AMap/ts-config';
import { FilterTypeEnum } from './components/TopContent/SearchFilter/ShopCircleFilter/FilterType';
import { getMallSelectionFlattenMap } from './components/TopContent/SearchFilter/ShopCircleFilter/ts-config';
import { isArray } from '@lhb/func';

export const CollectListContext = React.createContext<any>(null);
// export const SemirModelCode = 'senma_resource_mall_model_20250828';
// 20251216 言安通知更改森马模型code。群聊：【森马模型id更新影响解决】
export const SemirModelCode = 'senma_resource_mall_model_20251014';
// 需要特殊处理的直辖市（选择省时直接跳转市级别），这里之所以不用id，用名称是因为城市名不变的概率要远大于城市ID的概率
export const SpecificProvinces = [
  '北京',
  '天津',
  '上海',
];

/** 地图视角-枚举 */
export enum MapView {
  /** 全国视角 */
  National = 1,
  /** 省份视角 */
  Province = 2,
  /** 市视角 */
  City = 3,
  CompanyAll = 4,
  CompanyChild = 5,
}
/** 地图视角-选项 */
export const mapViews = [
  { value: MapView.National, label: '全国视角' },
  { value: MapView.Province, label: '省份视角' },
  { value: MapView.City, label: '市视角' },
];
/** 地图模式-枚举 */
export enum MapMode {
  /** 门店模式 */
  Store = 1,
  /** 城市模式 */
  City = 2,
  /** 省份模式 */
  Province = 3,
}
/** 地图模式-选项 */
export const mapModes = [
  { value: MapMode.Store, label: '门店模式' },
  { value: MapMode.City, label: '城市模式' },
  { value: MapMode.Province, label: '省份模式' },
];
/** 地图视角缩放级别 */
export enum MapViewZoom {
  /** 全国视角 */
  National = 5.04, // 首次加载时，地图显示的全国维度是5.04
  /** 省视角 */
  Province = 8,
  /** 市视角 */
  City = 10,
  /** 区视角 */
  District = 20,
}

/** 品牌商圈枚举-对应的是saas后台选址模型配置-青春版配置的品牌商圈选项
 * 1.不显示 2.通用(没啥用) 3 模板A(背后是小天才那一套)
 */
export enum BrandBusinessAreaType {
  /** 不显示 */
  Blank = 1,
  /** 通用 */
  Universal = 2,
  /** 模版A */
  TemplateaA = 3,
}

// 热力图模式
export enum HeatMode {
  NorMal = 1, // 普通
  Grid, // 网格
};


export interface MockDemo {
  a: Function;
}
/* 图层zIndex大全，非hover，非开启工具集 */
export const layerBaseZIndex = {
  cityFull: 1020, // 城市全屏卡片  marker图层
  markAddress: 1010, // 标记   marker图层
  ownBrand: 1000, // 自有品牌  marker图层
  footPrint: 500, // 踩点记录点  marker图层
  competitiveBrand: 500, // 竞品品牌  mass图层
  digital3C: 500, // 小米3C  mass图层
  point: 10, // 围栏中心点位圆圈  几何图层
};
/* 图层zIndex大全，hover */
export const layerHoverZIndex = {
  markAddress: 1101, // 标记   marker图层
  ownBrand: 1101, // 自有品牌  marker图层
  footPrint: 1101, // 踩点记录点  marker图层
  competitiveBrand: 1101, // 竞品品牌  mass图层
  digital3C: 1101, // 小米3C  mass图层
  companyLayer: 1, // 如果高于11就会挡住高德默认的标记，如杭州市等名称
};

export const layerCardHover = 2000;

export const HarmonyBrandId = 101077526; // 鸿蒙品牌id
export const AITOBrandId = 100427784; // 问界品牌id

export const SORT_DISTANCE_ID = 13; // 排序枚举-距离

// 地图要素显示-学校图层。dataType 当前都沿用原 school json，后续替换数据源时仅改这里。
export const mapFeatureSchoolId = 12;
export const mapFeatureSchoolOptions = [
  { id: 36, fallbackId: 'schoolOther', name: '其他', dataType: 'school', category: '其他' },
  { id: 35, fallbackId: 'schoolKindergarten', name: '幼儿园', dataType: 'school', category: '幼儿园' },
  { id: 34, fallbackId: 'schoolPrimary', name: '小学', dataType: 'school', category: '小学' },
  { id: 33, fallbackId: 'schoolMiddle', name: '中学', dataType: 'school', category: '中学' },
];
export const mapFeatureSchoolNames = mapFeatureSchoolOptions.map((item) => item.name);
export const mapFeatureSchoolVisibleIds = mapFeatureSchoolOptions.map((item) => item.id);
export const mapFeatureSchoolIds = mapFeatureSchoolOptions.reduce((pre: any[], item) => {
  return [...pre, item.id, item.fallbackId];
}, []);

/* 图层zIndex大全，开启工具集 */
// 汽车商圈 PointPolygon 固定 是10，处于最底部
export const toolSpecialOpenZIndex = {
  countryLayer: 120, // 全国矩形覆盖层   几何图形，仅为了让工具集可以点击穿透，无其他意义
  markAddress: 119, // 标记   marker图层
  ownBrand: 118, // 自有品牌  marker图层
  footPrint: 117, // 踩点记录点  marker图层
  // 海量点 需要低于110，才能被工具栏相关api穿透
  competitiveBrand: 109, // 竞品品牌  mass图层
  digital3C: 109, // 小米3C  mass图层
};

export const mapFilter = 'mapFilter';
/** 商圈筛选类型：全部、商场型 */
export const mapFilterType = 'mapFilterType';
export const mapTypeDimension = 'mapTypeDimension';
export const zoomOfClick = 17;
export enum firstLevelCategoryCodesEnum{
  'SD' = 'SD', // 商业
  'CY' = 'CY', // 汽车
  'HOME' = 'HOME', // 小米之家
  'FOOT_PRINT' = 'FOOT_PRINT', // 踩点记录
}
/** 热力图枚举 */
export enum heatMapCodesEnum {
  // 'HEATMAP', // 热力图
  // 'LIVE', // 居住人口热力
  // 'PERMANENT', // 常住人口热力
  // 'WORK', // 工作人口热力
  // 'CAR', // 汽车网点热力
  // 'MI_CAR', // 小米汽车保有量热力
  // 'MI_FANS', // 米粉热力
  Live = 1, // 居住人口
  Work = 2, // 工作人口
  Resident = 3, // 常住人口
  Catering = 4, // 餐饮热力
  Night = 5, // 夜间热力
  ActiveUser = 6, // 活跃热力用户
}

// 小天才活跃热力的 500m*500m 网格对应缩放范围。
export const activeUserHeatMap500GridMinZoom = 13;
export const activeUserHeatMap500GridMaxZoom = 15;

/**
 * @description 根据id匹配Marker
 * @param list MarkerList
 * @param id 匹配的id
 * @returns {marker,value}
 */
export const findMarkerById = (list:any[], id:number) => {
  const res:any = { marker: null, value: null };
  list.forEach((marker) => {
    const value = marker.getExtData();
    if (value.id === id) {
      res.marker = marker;
      res.value = value;
    }
  });
  return res;
};
export const iconEnum: any = {
  Digital3C: `${process.env.STATIC_RES_DOMAIN}/xiaomi/locationpc/mi_icon_3c.png`, // 3c
  Businessing: `${process.env.STATIC_RES_DOMAIN}/xiaomi/locationpc/mi_icon_orange.png`, // 已营业
  Constructing: `${process.env.STATIC_RES_DOMAIN}/xiaomi/locationpc/mi_icon_gray.png`, // 已决策
  BrandLogo: `${process.env.STATIC_RES_DOMAIN}/xiaomi/locationpc/selectionmap/brand-logo.png`, // 竞品logo
  Digital3CCircle: `${process.env.STATIC_RES_DOMAIN}/xiaomi/locationpc/mi_icon_3c_circle_orange.png`, // 3c 橙色圆点
};

export const businessRankOptions = [
  {
    label: '全部',
    value: -1,
  },
  {
    label: '前5',
    value: 5
  },
  {
    label: '前10',
    value: 10
  },
  {
    label: '前20',
    value: 20
  },
];

// 新增商圈的状态枚举
export enum newPointStatusEnum{
  NO_REVIEW=0, // 无需审核
  IN_REVIEW =1, // 待审核-审核中
  APPROVE = 2, // 审核通过
  REJECT = 9// 审核拒绝
}

// 数据给的热力，前面为范围大小(150m*150m)，后面为密度(每个间隔十几米)
export enum densityEnum {
  small= 3, // 整个城市（1km的网格）-- 目前没有该层级
  middle= 4, // 40km*20km（150米的网格）
  large=5, // 4km*2km（17米的网格）
};

export const showPolygonListKey = [
  `${firstLevelCategoryCodesEnum.CY}_rank`,
  `${firstLevelCategoryCodesEnum.CY}_name`,
  `${firstLevelCategoryCodesEnum.SD}_rank`,
  `${firstLevelCategoryCodesEnum.SD}_name`
];


/** 圈选查询数据对象 */
export interface drawSearchObjType {
  loadingObj: { // 圈选查询数据过滤，完成后会设为 true，优化抽屉空状态交互
    shops: Boolean;
  };
  /** 画框路径 */
  drawPath: Array<any>;
   /** 本品牌门店 */
  shops:Array<any>,
};

export function findNorthernmostCoordinate(lnglatArr: any[]) {
  if (lnglatArr?.length === 0) {
    return null;
  }
  // 初始化最北的经纬度为数组的第一个元素
  let northernmost = lnglatArr[0];
  // 遍历数组中的每个经纬度
  for (let i = 1; i < lnglatArr.length; i++) {
    // 如果当前经纬度的纬度值大于最北经纬度的纬度值
    if (lnglatArr[i][1] > northernmost[1]) {
      // 更新最北的经纬度
      northernmost = lnglatArr[i];
    }
  }
  return northernmost;
}
export const creating = 'creating';
export const collecting = 'collecting';
export const allData = 'allData';
export const rankOptions:any[] = [
  { key: creating, name: '生成中', value: creating },
  { key: collecting, name: '收藏', value: collecting },
  { key: 'rank', name: '全部', value: allData },
  { key: 'rank20', name: '前20名', value: 20 },
  { key: 'rank50', name: '前50名', value: 50 },
  { key: 'rank100', name: '前100名', value: 100 },
  { key: 'rank200', name: '前200名', value: 200 },
  { key: 'rank300', name: '前300名', value: 300 },
  { key: 'rank500', name: '前500名', value: 500 },
];
// 20251016版本改成了默认全部，改之前是默认前100
export const defaultSelectedRankOption = rankOptions[2];
// 地图中前xxx名的开店区域使用自定义Marker（rank是index索引）
export const useMarkerInAreaOfRank = 50;

export enum TabOption {
  /** 城市信息 */
  City = '1',
  /** 管理片区 */
  manageArea = '2',
  /** 品牌商圈（大圈） */
  brandBusinessArea = '3',
  /** 商圈信息(小圈) */
  Business = '4'
};
// 映射服务端返回的排序项
export enum ModelClusterSortRule {
  MarketScoreSort = 1, // 小圈列表 默认排序,即：市场评分排序
  MarketScoreSortBig = 1, // 大圈列表 默认排序,即：市场评分排序
  IndustrySort, // 行业评分
  DistanceSort, // 距离排序
  ShoppingMallDailySort, // 商场日均客流排序
  Population500Sort, // 周边500m居住人口
  Population3000Sort, // 周边3km居住人口
}


/** 筛选项枚举 */
export enum sectionKey {
  modelConfig='modelConfig', // 模型设置
  firstLevelCategory='firstLevelCategory', // 开店区域类型
  categoryMenu = 'categoryMenu', // 开店区域类型
  secondLevelCategoryCultureEducation='secondLevelCategoryCultureEducation', // 文教型
  secondLevelCategoryCommunity='secondLevelCategoryCommunity', // 社区型
  secondLevelCategoryTraffic='secondLevelCategoryTraffic', // 交通枢纽型
  secondLevelCategoryStreet='secondLevelCategoryStreet', // 街铺商圈型
  secondLevelCategoryOffice='secondLevelCategoryOffice', // 办公型
  secondLevelCategoryBusiness='secondLevelCategoryBusiness', // 商场型（商圈类型-其他：如 文教型、景区型、交通枢纽型、办公型、社区型）
  customizedField1='customizedField1', // 其他类型
  secondLevelCategoryScenicSpot='secondLevelCategoryScenicSpot', // 景区型
  secondLevelCategoryCompound='secondLevelCategoryCompound', // 复合型
  businessDistrictLevel='businessDistrictLevel', // 商圈等级
  area = 'area', // 行政区--no,
  districtMenu = 'districtMenu', // 行政区--no,
  labelSystemMall = 'labelSystemMall', // 开店区域标签
  suitabilityFilter = 'suitabilityFilter', // 是否合适
  labelSystemMenu='labelSystemMenu', // 开店区域标签-菜单
  labelSystemHighQuality = 'labelSystemHighQuality', // 商圈特性
  preferBrand='preferBrand',
  preferBrandMenu = 'preferBrandMenu', // 偏好品牌--no
  shopOpenTimeTypes = 'shopOpenTimeTypes', // 开业时间
  shopCloseTimeTypes = 'shopCloseTimeTypes', // 闭店时间
  avoidBrand = 'avoidBrand', // 避开品牌--no
  avoidBrandMenu = 'avoidBrandMenu', // 避开品牌--no
  mallMenu='mallMenu', // 商圈特性菜单
  mallLevel='mallLevel', // 商场定位
  mallSize='mallSize', // 商场规模
  mallOpenYears='mallOpenYears', // 商场开业时长
  cateringMenu ='cateringMenu', // 餐饮门店菜单
  cateringStore = 'cateringStore', // 门店数
  oldCateringStore = 'oldCateringStore', // 存续门店3年老店比例
  residentsMenu = 'residentsMenu', // 居住人口菜单
  population = 'population', // 500m人口聚集度
  population3km = 'population3km', // 3km人口聚集度
  marketScore = 'marketScore', // 市场评分
  marketScoreMenu = 'marketScoreMenu', // 市场评分
  flowPortraitMenu='flowPortraitMenu', // 商场客流画像
  passFlow = 'passFlow', // 商场日均客流指数
  gender = 'gender', // 性别
  carProportion = 'carProportion', // 有车客群比例
  facility='facility', // 周边配套（500m）
  surroundingMenu = 'surroundingMenu', // 周边配套
  workType ='workType', // 办公
  schoolType = 'schoolType', // 学校
  trafficType='trafficType', // 交通
  scenicType='scenicType', // 景区
  medicalType ='medicalType', // 医院
  otherType = 'otherType', // 其他市场
  houseCharacteristicsMenu = 'houseCharacteristicsMenu', // 小区特性菜单
  households = 'households', // 小区户数
  housePrice = 'housePrice', // 周边房屋均价
  houseYear = 'houseYear', // 小区建筑年代
  tourBrand='tourBrand', // 巡展品牌
  tourBrandMenu='tourBrandMenu', // 巡展品牌
  developerBrand='developerBrand', // 开发商品牌
  labelSystemRegionalProtection='labelSystemRegionalProtection', // 区域保护
  labelSystemSource='labelSystemSource', // 来源
  labelSystemStandardChancePoint='labelSystemStandardChancePoint', // 机会点
  labelSystemSelfBrand='labelSystemSelfBrand', // 本品牌/门店覆盖
  labelSystemStandardTask='labelSystemStandardTask', // 拓店任务
  labelSystemPlanSpot='labelSystemPlanSpot', // 集客点
  labelSystemFavorites='labelSystemFavorites', // 收藏
  labelSystemSuitability='labelSystemSuitability', // 适合度
  favoriteMenu='favoriteMenu', // 收藏夹菜单
  favorite='favorite', // 收藏夹
  customLabelMenu='customLabelMenu', // 自定义标签菜单
  customLabelGroups='customLabelGroups', // 自定义标签
  // ps：这里直接用枚举值会报错“Computed values are not permitted in an enum with string valued members.”
  // brand=layerSelectionEnum.SELF_BRAND_SHOP, // 本品牌门店
  brand=1, // 本品牌门店
  // competitorBrand=layerSelectionEnum.COMPETITION_BRAND, // 竞品品牌
  competitorBrand=2, // 竞品品牌
  // famousBrand=layerSelectionEnum.FAMOUS_BRAND, // 知名品牌
  famousBrand=3, // 知名品牌
  // collectArea=layerSelectionEnum.FAVORITES, // 收藏的开店区域
  collectArea=4, // 收藏的开店区域
  // community=layerSelectionEnum.HOUSE, // 图层设置-小区
  community=5, // 图层设置-小区
  openArea=6, // 开店区域

  /** 商圈筛选类型：全部、商场型 */
  filterType = 'filterType',

  /** 商场型筛选项 */
  mallSelections = 'mallSelections',
  /** 商场定位-模块 */
  mallPosition = 'mallPosition',
  /** 商场等级 */
  projectLevel= 'projectLevel',
  /** 商场档次 */
  projectGrade = 'projectGrade',
  /** 商场品牌定位 */
  brandPosition = 'brandPosition',
  /** 商场业态 */
  projectIndustry = 'projectIndustry',
  /** 项目品牌-模块 */
  projectBrandMenu = 'projectBrandMenu',
  /** 连锁品牌等级 */
  brandLevel = 'brandLevel',
  /** 项目品牌 */
  projectBrand = 'projectBrand',
  /** 热门商场-模块 */
  hotMallMenu = 'hotMallMenu',
  /** 热门商场 */
  hotMall = 'hotMall',
  /** 客流排名-模块 */
  flowRank = 'flowRank',
  /** 客流排名 */
  cityRank = 'cityRank',
  /** 工作日客流排名 */
  weekdayRank = 'weekdayRank',
  /** 节假日客流排名 */
  weekendRank = 'weekendRank',
  /** 客群画像-模块 */
  customerProfile = 'customerProfile',
  /** 消费人群档次 */
  consumerLevel = 'consumerLevel',
  /** 消费人群年龄 */
  consumerAgeGroup = 'consumerAgeGroup',
  /** 开业时间-模块 */
  openDate = 'openDate',
  /** 时间分段 */
  openDuration = 'openDuration',
  /** 商业面积-模块 */
  mallArea = 'mallArea',
  /** 面积规模 */
  mallAreaScale = 'mallAreaScale',
}

/**
 * 商圈显示筛选-全部型筛选的 keys
 * @description 方便多个地方复用和统一维护
 */
export const filterTypeAllSectionKeys = [
  /* 商圈类型 */
  sectionKey.firstLevelCategory,
  sectionKey.secondLevelCategoryBusiness,
  sectionKey.customizedField1,
  sectionKey.businessDistrictLevel, // 商圈等级
  /* 商圈标签 */
  sectionKey.labelSystemSelfBrand, // 门店覆盖/本品牌
  sectionKey.labelSystemStandardChancePoint, // 机会点
  sectionKey.labelSystemStandardTask, // 拓店任务
  sectionKey.labelSystemSuitability, // 适合度
  sectionKey.labelSystemPlanSpot, // 集客点
  sectionKey.labelSystemFavorites, // 标签：收藏
  sectionKey.labelSystemRegionalProtection, // 区域保护
  sectionKey.labelSystemSource, // 来源
  sectionKey.suitabilityFilter, // 是否合适
  /* 商场特性 */
  sectionKey.mallLevel, // 商场定位
  sectionKey.mallSize, // 商场规模
  sectionKey.mallOpenYears, // 商场开业时长
  /* 商场客流画像 */
  sectionKey.passFlow, // 日均客流
  sectionKey.gender, // 性别
  sectionKey.carProportion, // 有车客群比例
  /* 偏好品牌 */
  sectionKey.preferBrand,
  sectionKey.shopOpenTimeTypes, // 开业时间
  sectionKey.shopCloseTimeTypes, // 闭店时间
  /* 避开品牌 */
  sectionKey.avoidBrand,
  /* 小区特性 */
  sectionKey.households, // 小区户数
  sectionKey.housePrice, // 周边房屋均价
  sectionKey.houseYear, // 小区建筑年代
  /* 居住人口 */
  sectionKey.population, // 500m人口聚集度
  sectionKey.population3km, // 3km人口聚集度
  /* 周边配套 */
  sectionKey.workType, // 办公
  sectionKey.schoolType, // 学校
  sectionKey.trafficType, // 交通
  sectionKey.scenicType, // 景区
  sectionKey.medicalType, // 医院
  sectionKey.otherType, // 其他市场
  /* 市场评分 */
  sectionKey.marketScore,
  /* 餐饮门店 */
  sectionKey.cateringStore, // 门店数
  sectionKey.oldCateringStore, // 存续门店3年老店比例
  /* 收藏夹 */
  sectionKey.favorite,
  /* 自定义标签 */
  sectionKey.customLabelMenu, // TODO 是否需要
  sectionKey.customLabelGroups,
];

/**
 * 商圈显示筛选-商场型筛选的 keys
 * @description 方便多个地方复用和统一维护
 */
export const filterTypeMallSectionKeys = [
  // 商场定位
  sectionKey.projectLevel, sectionKey.projectGrade, sectionKey.brandPosition, sectionKey.projectIndustry,
  // 项目品牌
  sectionKey.brandLevel, sectionKey.projectBrand,
  // 热门商场
  sectionKey.hotMall,
  // 客流排名
  sectionKey.cityRank, sectionKey.weekdayRank, sectionKey.weekendRank,
  // 客群画像
  sectionKey.consumerLevel, sectionKey.consumerAgeGroup,
  // 开业时间
  sectionKey.openDuration,
  // 商业面积
  sectionKey.mallAreaScale,
  // 偏好品牌
  sectionKey.preferBrand,
  // 避开品牌
  sectionKey.avoidBrand,
];

/**
 * 商圈显示筛选-商场型筛选的 keys 的中文映射表
 * @description 方便多个地方复用和统一维护
 */
export const filterTypeMallSectionKeysCNMap = {
  // 商场定位
  [sectionKey.mallPosition]: '商场定位',
  [sectionKey.projectLevel]: '商场等级',
  [sectionKey.projectGrade]: '商场档次',
  [sectionKey.brandPosition]: '商场品牌定位',
  [sectionKey.projectIndustry]: '商场业态',
  // 项目品牌
  [sectionKey.projectBrandMenu]: '项目品牌',
  [sectionKey.brandLevel]: '连锁品牌等级',
  [sectionKey.projectBrand]: '项目品牌',
  // 热门商场
  [sectionKey.hotMallMenu]: '热门商场',
  [sectionKey.hotMall]: '热门商场',
  // 客流排名
  [sectionKey.flowRank]: '客流排名',
  [sectionKey.cityRank]: '客流排名',
  [sectionKey.weekdayRank]: '工作日客流排名',
  [sectionKey.weekendRank]: '节假日客流排名',
  // 客群画像
  [sectionKey.customerProfile]: '客群画像',
  [sectionKey.consumerLevel]: '消费人群档次',
  [sectionKey.consumerAgeGroup]: '消费人群年龄',
  // 开业时间
  [sectionKey.openDate]: '开业时间',
  [sectionKey.openDuration]: '时间分段',
  // 商业面积
  [sectionKey.mallArea]: '商业面积',
  [sectionKey.mallAreaScale]: '面积规模',
  // 偏好品牌
  [sectionKey.preferBrandMenu]: '偏好品牌',
  [sectionKey.preferBrand]: '偏好品牌',
  // 避开品牌
  [sectionKey.avoidBrandMenu]: '避开品牌',
  [sectionKey.avoidBrand]: '避开品牌',
};

//  与modelCluster/es/selection/list中menuStructure的code一致
// 注意里面的字段不要随便更改，更改的时候一定要确认影响范围！！！
// openingAreaAliasCompulsive字段是为了适配默写KA大客户的强制需求。
export const useLeftSection = (openingAreaAlias) => {
  return [
    { label: `${openingAreaAlias}类型`, code: sectionKey.categoryMenu, remark: `多样化${openingAreaAlias}选择，轻松定位您的目标${openingAreaAlias}`,
      children: [
        { label: '商业区', code: sectionKey.secondLevelCategoryBusiness },
        // { label: '文教型', code: sectionKey.secondLevelCategoryCultureEducation },
        // { label: '社区型', code: sectionKey.secondLevelCategoryCommunity },
        // { label: '交通枢纽型', code: sectionKey.secondLevelCategoryTraffic },
        // { label: '街铺商圈型', code: sectionKey.secondLevelCategoryStreet },
        // { label: '办公型', code: sectionKey.secondLevelCategoryOffice },
        // { label: '景区型', code: sectionKey.secondLevelCategoryScenicSpot	 },
        // { label: '复合型', code: sectionKey.secondLevelCategoryCompound	 },
        { label: '其他', code: sectionKey.firstLevelCategory },
        { label: '商圈等级', code: sectionKey.businessDistrictLevel },
        { label: '其他类型', code: sectionKey.customizedField1 },
      ]
    },
    // { label: '行政区', code: sectionKey.districtMenu, remark: '筛选特定行政区域，精准定位选址布局',
    //   children: [
    //     { label: '行政区', code: sectionKey.area, remark: '筛选特定行政区域，精准定位选址布局', }
    //   ]
    // },
    {
      label: `${openingAreaAlias}标签`, code: sectionKey.labelSystemMenu, remark: `利用细分标签，快速识别${openingAreaAlias}特色`,
      children: [
        // 20240606版本先隐藏  规划：标签还是要做的功能，6月下的版本中，重点优化开店区域标签

        { label: '门店覆盖', code: sectionKey.labelSystemSelfBrand, },
        { label: '集客点', code: sectionKey.labelSystemPlanSpot, },
        { label: '拓店任务', code: sectionKey.labelSystemStandardTask, },
        { label: '机会点', code: sectionKey.labelSystemStandardChancePoint, },
        { label: '收藏', code: sectionKey.labelSystemFavorites, },
        { label: '区域保护', code: sectionKey.labelSystemRegionalProtection, },
        { label: '来源', code: sectionKey.labelSystemSource, },
        { label: '适合度', code: sectionKey.labelSystemSuitability, },
        { label: '是否合适', code: sectionKey.suitabilityFilter, },
      ]
    },
    // { label: '开发商品牌', code: 'developerBrandMenu', remark: '查询所属开发品牌的商场', children: [
    //   { label: '开发商品牌', code: 'developerBrand', }
    // ] },
    {
      label: '商场特性', code: sectionKey.mallMenu, remark: `利用细分标签，快速识别${openingAreaAlias}特色，轻松定位您的目标商场`,
      children: [
        { label: '商场定位', code: sectionKey.mallLevel, },
        { label: '商场规模', code: sectionKey.mallSize, },
        { label: '商场开业时长', code: sectionKey.mallOpenYears, },
      ]
    },
    {
      label: '商场客流画像', code: sectionKey.flowPortraitMenu, remark: `查询符合客流人群画像的${openingAreaAlias}`,
      children: [
        { label: '日均客流', code: sectionKey.passFlow, },
        { label: '性别', code: sectionKey.gender, },
        // { label: '年龄', code: 'age', }, // 设计缺陷 0606版本隐藏掉
        { label: '有车客群比例', code: sectionKey.carProportion, },
      ]
    },
    { label: '偏好品牌', code: sectionKey.preferBrandMenu, remark: `查询周边500m有此品牌的${openingAreaAlias}`, children: [
      { label: '偏好品牌', code: sectionKey.preferBrand, },
      { label: '开业时间', code: sectionKey.shopOpenTimeTypes, },
      { label: '闭店时间', code: sectionKey.shopCloseTimeTypes, },
    ] },
    { label: '避开品牌', code: sectionKey.avoidBrandMenu, remark: `避开周边500m有此品牌的${openingAreaAlias}`, children: [
      { label: '避开品牌', code: sectionKey.avoidBrand, }
    ] },
    // { label: '多经点位', code: 'multiplePointsMenu', remark: '查询拥有以下条件的巡展点位商场',
    //   children: [
    //     { label: '历史是否有汽车巡展', code: 'historyCarTour', },
    //     { label: '场地面积', code: 'pointArea', },
    //     { label: '类型', code: 'locationType', },
    //     { label: '楼层', code: 'floor', },
    //   ]
    // },
    // { label: '巡展品牌', code: sectionKey.tourBrandMenu, remark: `历史在${openingAreaAlias}开过快慢闪店的品牌`, children: [
    //   { label: '巡展品牌', code: sectionKey.tourBrand }
    // ] }, // todo-需要重新请求
    // // { label: '巡展车型', code: '', remark: '历史在商圈开过快慢闪店的车型',
    // //   children: [
    // //     { label: '价格', code: '' },
    // //     { label: '能源', code: '' }
    // //   ]
    // // }, // todo 巡展车型 整个二级筛选都还没有--目前不做
    { label: '小区特性', code: sectionKey.houseCharacteristicsMenu, remark: `查询周边500m小区特性符合要求的${openingAreaAlias}`,
      children: [
        { label: '小区户数', code: sectionKey.households },
        { label: '小区房价', code: sectionKey.housePrice },
        { label: '建筑年代', code: sectionKey.houseYear },
      ]
    },
    { label: '居住人口', code: sectionKey.residentsMenu, remark: '根据周边500m、3km内居住人口筛选',
      children: [
        { label: '500m人口聚集度', code: sectionKey.population },
        { label: '3km人口聚集度', code: sectionKey.population3km },
      ]
    },
    { label: '周边配套', code: sectionKey.surroundingMenu, remark: `查询中心点周边500m内有此配套的${openingAreaAlias}`,
      children: [
        { label: '办公', code: sectionKey.workType },
        { label: '学校', code: sectionKey.schoolType },
        { label: '交通', code: sectionKey.trafficType },
        { label: '景区', code: sectionKey.scenicType },
        { label: '医院', code: sectionKey.medicalType },
        { label: '其他市场', code: sectionKey.otherType },
      ]
    },
    { label: '市场评分', code: sectionKey.marketScoreMenu, remark: `衡量${openingAreaAlias}竞争力的关键指标，分数越高代表整体市场表现越好`, children: [
      { label: '市场评分', code: sectionKey.marketScore, }
    ] },
    { label: '餐饮门店', code: sectionKey.cateringMenu, remark: '餐饮门店和餐饮老店占比合并',
      children: [
        { label: '门店数', code: sectionKey.cateringStore },
        { label: '存续门店3年老店比例', code: sectionKey.oldCateringStore },
      ]
    },
    { label: '收藏夹', code: sectionKey.favoriteMenu, remark: '收藏夹',
      children: [
        { label: '收藏夹', code: sectionKey.favorite },
      ]
    },
    { label: '自定义标签', code: sectionKey.customLabelMenu, remark: '自定义标签',
      children: [
        { label: '自定义标签', code: sectionKey.customLabelGroups },
      ]
    },
  ];
};

export const customLabelsPrefix = 'customLable_';

/**
 * 重置动态选项：部分字段设置为默认值，部分字段设置为空数组
 * @description 如果 selection 选项内没有对应的字段，那么该字段重置为空数组
 * @param selection 筛选条件
 * @param value 筛选值
 * @param filterType 商圈筛选类型：全部、商场型，必传，用于判断是否需要重置相关的筛选条件
 */
export function resetDynamic(selection, value, filterType) {
  // console.log('value', value);

  const newValue = { ...value };

  if (filterType === FilterTypeEnum.Mall) { // 商场型筛选

    /** 商圈筛选右侧列表选项映射表，取自 leftSection 的二级选项
     * @description 如
     * {
        "projectLevel": {
          "name": "商场等级",
          "code": "projectLevel",
          "children": [{ "name": "S级", "code": "1", "children": [], "label": "S级" }, { "name": "A级", "code": "2", "children": [], "label": "A级" }],
        }
      } */
    const mallSelectionFlattenMap = getMallSelectionFlattenMap(selection?.[sectionKey.mallSelections]);

    // 商场型筛选没有默认值，所以不处理默认值
    filterTypeMallSectionKeys.forEach(key => {
      if (key === sectionKey.preferBrand) {
        // 不存在“偏好品牌”，这里必须写死，因为 res和返回的selection里都已经可能没有preferBrandMenu了
        if (!selection.menuStructure.find(item => item.encode === sectionKey.preferBrandMenu)) {
          newValue[key] = [];
        }
      } else if (key === sectionKey.avoidBrand) {
        // 不存在“避开品牌”，这里必须写死，因为 res和返回的selection里都已经可能没有avoidBrandMenu了
        if (!selection.menuStructure.find(item => item.encode === sectionKey.avoidBrandMenu)) {
          newValue[key] = [];
        }
      } else {
        if (!mallSelectionFlattenMap[key]) { // 判断 mallSelectionFlattenMap 是否存在该 key，不存在则设置为空数组
          newValue[key] = [];
        }
      }
    });
  } else { // 全部型筛选
    // 是否存在“商圈类型”
    if (selection.menuStructure.find(item => item.encode === sectionKey.categoryMenu)) {
      const newFirstOptionIds = selection[sectionKey.firstLevelCategory]?.map(item => item.id) || [];
      const newFirstValue = newValue[sectionKey.firstLevelCategory].filter(item => newFirstOptionIds?.includes(item));
      const newSecondOptionIds = selection[sectionKey.secondLevelCategoryBusiness]?.map(item => item.id);
      const newSecondValue = newValue[sectionKey.secondLevelCategoryBusiness].filter(item => newSecondOptionIds?.includes(item));
      const newCustomizedField1OptionIds = selection[sectionKey.customizedField1]?.map(item => item.id);
      const newCustomizedField1Value = newValue[sectionKey.customizedField1].filter(item => newCustomizedField1OptionIds?.includes(item));
      newValue[sectionKey.firstLevelCategory] = newFirstValue;
      newValue[sectionKey.secondLevelCategoryBusiness] = newSecondValue;
      newValue[sectionKey.customizedField1] = newCustomizedField1Value;
      if (!selection[sectionKey.businessDistrictLevel]?.length) { // 如果不存在商圈等级
        newValue[sectionKey.businessDistrictLevel] = [];
      }
    } else {
      newValue[sectionKey.firstLevelCategory] = [];
      newValue[sectionKey.secondLevelCategoryBusiness] = [];
      newValue[sectionKey.businessDistrictLevel] = []; // 商圈等级
      newValue[sectionKey.customizedField1] = []; // 商圈等级
    }
    // 不存在“商圈标签”，这里必须写死，因为 res和返回的selection里都已经可能没有labelSystemMenu了
    if (!selection.menuStructure.find(item => item.encode === sectionKey.labelSystemMenu)) {
      newValue[sectionKey.labelSystemSelfBrand] = []; // 本品牌/门店覆盖
      newValue[sectionKey.labelSystemPlanSpot] = []; // 集客点
      newValue[sectionKey.labelSystemStandardTask] = []; // 拓店任务
      newValue[sectionKey.labelSystemStandardChancePoint] = []; // 机会点
      newValue[sectionKey.labelSystemFavorites] = []; // 收藏
      newValue[sectionKey.labelSystemRegionalProtection] = []; // 区域保护
      newValue[sectionKey.labelSystemSource] = []; // 来源
      newValue[sectionKey.labelSystemSuitability] = []; // 适合度
    } else {
      if (!selection[sectionKey.labelSystemSelfBrand]?.length) { // 如果不存在本品牌/门店覆盖
        newValue[sectionKey.labelSystemSelfBrand] = [];
      }
      if (!selection[sectionKey.labelSystemPlanSpot]?.length) { // 如果不存在集客点
        newValue[sectionKey.labelSystemPlanSpot] = [];
      }
      if (!selection[sectionKey.labelSystemStandardTask]?.length) { // 如果不存在拓店任务
        newValue[sectionKey.labelSystemStandardTask] = [];
      }
      if (!selection[sectionKey.labelSystemStandardChancePoint]?.length) { // 如果不存在机会点
        newValue[sectionKey.labelSystemStandardChancePoint] = [];
      }
      if (!selection[sectionKey.labelSystemFavorites]?.length) { // 如果不存在收藏
        newValue[sectionKey.labelSystemFavorites] = [];
      }
      if (!selection[sectionKey.labelSystemRegionalProtection]?.length) { // 如果不存在区域保护
        newValue[sectionKey.labelSystemRegionalProtection] = [];
      }
      if (!selection[sectionKey.labelSystemSource]?.length) { // 如果不存在来源
        newValue[sectionKey.labelSystemSource] = [];
      }
      if (!selection[sectionKey.labelSystemSuitability]?.length) { // 如果不存在适合度
        newValue[sectionKey.labelSystemSuitability] = [];
      }
    }
    // 不存在“商圈特性”，这里必须写死，因为 res和返回的selection里都已经可能没有mallMenu了
    if (!selection.menuStructure.find(item => item.encode === sectionKey.mallMenu)) {
      newValue[sectionKey.mallLevel] = []; // 商场定位
      newValue[sectionKey.mallSize] = []; // 商场规模
      newValue[sectionKey.mallOpenYears] = []; // 商场开业市场
    } else {
      if (!selection[sectionKey.mallLevel]?.length) { // 如果不存在商场定位
        newValue[sectionKey.mallLevel] = [];
      }
      if (!selection[sectionKey.mallSize]?.length) { // 如果不存在商场规模
        newValue[sectionKey.mallSize] = [];
      }
      if (!selection[sectionKey.mallOpenYears]?.length) { // 如果不存在商场开业市场
        newValue[sectionKey.mallOpenYears] = [];
      }
    }

    // 不存在“客流画像”，这里必须写死，因为 res和返回的selection里都已经可能没有flowPortraitMenu了
    if (!selection.menuStructure.find(item => item.encode === sectionKey.flowPortraitMenu)) {
      newValue[sectionKey.passFlow] = []; // 商场日均客流指数
      newValue[sectionKey.gender] = []; // 性别
      newValue[sectionKey.carProportion] = []; // 有车客群比例
    } else {
      if (!selection[sectionKey.passFlow]?.length) { // 如果不存在商场日均客流指数
        newValue[sectionKey.passFlow] = [];
      }
      if (!selection[sectionKey.gender]?.length) { // 如果不存在性别
        newValue[sectionKey.gender] = [];
      }
      if (!selection[sectionKey.carProportion]?.length) { // 如果不存在有车客群比例
        newValue[sectionKey.carProportion] = [];
      }
    }
    // 不存在“偏好品牌”，这里必须写死，因为 res和返回的selection里都已经可能没有preferBrandMenu了
    if (!selection.menuStructure.find(item => item.encode === sectionKey.preferBrandMenu)) {
      newValue[sectionKey.preferBrand] = [];
    }
    // 不存在“避开品牌”，这里必须写死，因为 res和返回的selection里都已经可能没有avoidBrandMenu了
    if (!selection.menuStructure.find(item => item.encode === sectionKey.avoidBrandMenu)) {
      newValue[sectionKey.avoidBrand] = [];
    }
    // 不存在“小区特性”，这里必须写死，因为 res和返回的selection里都已经可能没有houseCharacteristicsMenu了
    if (!selection.menuStructure.find(item => item.encode === sectionKey.houseCharacteristicsMenu)) {
      newValue[sectionKey.households] = []; // 小区户数
      newValue[sectionKey.housePrice] = []; // 周边房屋均价
      newValue[sectionKey.houseYear] = []; // 小区建筑年代
    } else {
      if (!selection[sectionKey.households]?.length) { // 如果不存在小区户数
        newValue[sectionKey.households] = [];
      }
      if (!selection[sectionKey.housePrice]?.length) { // 如果不存在周边房屋均价
        newValue[sectionKey.housePrice] = [];
      }
      if (!selection[sectionKey.houseYear]?.length) { // 如果不存在小区建筑年代
        newValue[sectionKey.houseYear] = [];
      }
    }
    // 不存在“居住人口”，这里必须写死，因为 res和返回的selection里都已经可能没有residentsMenu了
    if (!selection.menuStructure.find(item => item.encode === sectionKey.residentsMenu)) {
      newValue[sectionKey.population] = []; // 500m人口聚集度
      newValue[sectionKey.population3km] = []; // 3km人口聚集度
    } else {
      if (!selection[sectionKey.population]?.length) { // 如果不存在500m人口聚集度
        newValue[sectionKey.population] = [];
      }
      if (!selection[sectionKey.population3km]?.length) { // 如果不存在3km人口聚集度
        newValue[sectionKey.population3km] = [];
      }
    }
    // 不存在“周边配套”，这里必须写死，因为 res和返回的selection里都已经可能没有surroundingMenu了
    if (!selection.menuStructure.find(item => item.encode === sectionKey.surroundingMenu)) {
      newValue[sectionKey.workType] = []; // 办公
      newValue[sectionKey.schoolType] = []; // 学校
      newValue[sectionKey.trafficType] = []; // 交通
      newValue[sectionKey.scenicType] = []; // 景区
      newValue[sectionKey.medicalType] = []; // 医院
      newValue[sectionKey.otherType] = []; // 其他市场
    } else {
      if (!selection[sectionKey.workType]?.length) { // 如果不存在办公
        newValue[sectionKey.workType] = [];
      }
      if (!selection[sectionKey.schoolType]?.length) { // 如果不存在学校
        newValue[sectionKey.schoolType] = [];
      }
      if (!selection[sectionKey.trafficType]?.length) { // 如果不存在交通
        newValue[sectionKey.trafficType] = [];
      }
      if (!selection[sectionKey.scenicType]?.length) { // 如果不存在景区
        newValue[sectionKey.scenicType] = [];
      }
      if (!selection[sectionKey.medicalType]?.length) { // 如果不存在医院
        newValue[sectionKey.medicalType] = [];
      }
      if (!selection[sectionKey.otherType]?.length) { // 如果不存在其他市场
        newValue[sectionKey.otherType] = [];
      }
    }
    // 不存在“市场评分”，这里必须写死，因为 res和返回的selection里都已经可能没有marketScoreMenu了
    if (!selection.menuStructure.find(item => item.encode === sectionKey.marketScoreMenu)) {
      newValue[sectionKey.marketScore] = [];
    } else {
      if (!selection[sectionKey.marketScore]?.length) { // 如果不存在市场评分
        newValue[sectionKey.marketScore] = [];
      }
    }
    // 不存在“餐饮门店”，这里必须写死，因为 res和返回的selection里都已经可能没有cateringMenu了
    if (!selection.menuStructure.find(item => item.encode === sectionKey.cateringMenu)) {
      newValue[sectionKey.cateringStore] = []; // 门店数
      newValue[sectionKey.oldCateringStore] = []; // 存续门店3年老店比例
    } else {
      if (!selection[sectionKey.cateringStore]?.length) { // 如果不存在门店数
        newValue[sectionKey.cateringStore] = [];
      }
      if (!selection[sectionKey.oldCateringStore]?.length) { // 如果不存在存续门店3年老店比例
        newValue[sectionKey.oldCateringStore] = [];
      }
    }
    // 不存在“收藏夹”，这里必须写死，因为 res和返回的selection里都已经可能没有cateringMenu了
    if (!selection.menuStructure.find(item => item.encode === sectionKey.favoriteMenu)) {
      newValue[sectionKey.favorite] = []; // 收藏夹
    }
    // 不存在“自定义标签”，这里必须写死，因为 res和返回的selection里都已经可能没有customLabelMenu了
    if (!selection.menuStructure.find(item => item.encode === sectionKey.customLabelMenu)) {
      // 直接删除
      for (const key in newValue) {
        if (key.startsWith(customLabelsPrefix)) {
          delete newValue[key];
        }
      }
    }

  }

  return newValue;
}
// 鼠标滑过地图时，hover后需要请求接口的场景，最小停留时间(单位：ms)后才开始接口请求。
export const HOVER_STAY_TIME = 300;

/**
 * @description 根据城市id寻找对应的城市信息
 * @param provincesCities store中的provincesCities数据
 * @param cityId 当前城市id
 * @returns 城市信息（附带所在省份部分数据）
 */
export const findCurCItyInfo = (provincesCities, cityId) => {
  let city;
  provincesCities?.forEach((province) => {
    province?.children?.forEach((item) => {
      if (item.id === cityId) {
        city = {
          ...item,
          provinceName: province?.name,
          provinceId: province?.id,
          pinyin: province?.pinyin,
        };
      }
    });
  });
  return city;
};

/** 项目等级标签（小天才） */
export const XTCLabel: any = {
  'A级': `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/xtc/xtc_label_A@2x.png`,
  'B级': `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/xtc/xtc_label_B@2x.png`,
  'C级': `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/xtc/xtc_label_C@2x.png`,
  'D级': `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/xtc/xtc_label_D@2x.png`,
  'S级': `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/xtc/xtc_label_S@2x.png`,
};

/** 大全围栏填充色透明度 */
export const BigCircleFillOpacity = 0.12;
/** 大圈围栏颜色 */
export const BigCircleRailColor: any = {
  '1': { // S级
    default: {
      strokeColor: '#FF7070',
      strokeWeight: 1,
      fillColor: '#FF7070',
      fillOpacity: BigCircleFillOpacity,
      strokeOpacity: 1,
    },
    active: {
      strokeColor: '#FF7070',
      strokeWeight: 3,
      fillColor: '#FF7070',
      fillOpacity: 0,
      strokeOpacity: 1,
    },
    weak: {
      strokeOpacity: 0.3,
      fillOpacity: 0.036,
    }
  },
  '2': { // A级
    default: {
      strokeColor: '#FF70C7',
      strokeWeight: 1,
      fillColor: '#FF70C7',
      fillOpacity: BigCircleFillOpacity,
      strokeOpacity: 1,
    },
    active: {
      strokeColor: '#FF70C7',
      strokeWeight: 3,
      fillColor: '#FF70C7',
      fillOpacity: 0,
      strokeOpacity: 1,
    },
    weak: {
      strokeOpacity: 0.3,
      fillOpacity: 0.036,
    }
  },
  '3': { // B级
    default: {
      strokeColor: '#B973FF',
      strokeWeight: 1,
      fillColor: '#B973FF',
      fillOpacity: BigCircleFillOpacity,
      strokeOpacity: 1,
    },
    active: {
      strokeColor: '#B973FF',
      strokeWeight: 3,
      fillColor: '#B973FF',
      fillOpacity: 0,
      strokeOpacity: 1,
    },
    weak: {
      strokeOpacity: 0.3,
      fillOpacity: 0.036,
    }
  },
  '4': { // C级
    default: {
      strokeColor: '#02C681',
      strokeWeight: 1,
      fillColor: '#02C681',
      fillOpacity: BigCircleFillOpacity,
      strokeOpacity: 1,
    },
    active: {
      strokeColor: '#02C681',
      strokeWeight: 3,
      fillColor: '#02C681',
      fillOpacity: 0,
      strokeOpacity: 1,
    },
    weak: {
      strokeOpacity: 0.3,
      fillOpacity: 0.036,
    }
  },
  '5': { // D级
    default: {
      strokeColor: '#4291FF',
      strokeWeight: 1,
      fillColor: '#4291FF',
      fillOpacity: BigCircleFillOpacity,
      strokeOpacity: 1,
    },
    active: {
      strokeColor: '#4291FF',
      strokeWeight: 3,
      fillColor: '#4291FF',
      fillOpacity: 0,
      strokeOpacity: 1,
    },
    weak: {
      strokeOpacity: 0.3,
      fillOpacity: 0.06,
    }
  },
};

// 处理来源（又名新增商圈）
function handleUserCustomFlag(filter) {
  const ids = filter.newShopsCircle[sectionKey.labelSystemSource];
  if (ids?.length > 1 || !ids?.length) {
    return undefined;
  } else {
    return ids[0] === 2; // 新增时true，推荐是false
  }
};

/** 商圈筛选参数处理 */
export const getBusinessCircleParams = (filter) => {
  const _params: any = {};
  const modelConfigId = filter.newShopsCircle?.[sectionKey.modelConfig]?.[0];
  if (modelConfigId) {
    // 模型id
    _params.modelConfigId = modelConfigId;

    // console.log('filter', filter);

    _params[sectionKey.filterType] = filter.filterType;

    if (filter.filterType === FilterTypeEnum.Mall) { // 商圈筛选-商场型
      if (filter.shopsLayer) { // 是否选中商圈筛选
        filterTypeMallSectionKeys.forEach(key => {
          _params[key] = filter.newShopsCircle?.[key] || [];
        });
        // 处理特殊字段
        /* 偏好品牌 */
        _params.preferBrandIds = filter.newShopsCircle?.[sectionKey.preferBrand];
        /* 避开品牌 */
        _params.avoidBrandIds = filter.newShopsCircle?.[sectionKey.avoidBrand];
        _params.shopOpenCloseTimeTypes = [
          ...(filter.newShopsCircle?.[sectionKey.shopOpenTimeTypes] || []),
          ...(filter.newShopsCircle?.[sectionKey.shopCloseTimeTypes] || []),
        ];
      }
    } else { // 商圈筛选-全部型

      const firstLevelCategories = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.firstLevelCategory] || [] : []; // 一级商圈类型
      const secondLevelCategories = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.secondLevelCategoryBusiness] || [] : []; // 二级商圈类型-仅商场型
      const customizedField1s = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.customizedField1] || [] : []; // 其他类型
      // firstLevelCategories 和 secondLevelCategories如果同时是空数组的时候，接口层面目前是相当于全选
      _params.firstLevelCategories = firstLevelCategories;
      _params.secondLevelCategories = secondLevelCategories;
      _params.customizedField1s = customizedField1s;

      const businessDistrictLevels = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.businessDistrictLevel] || [] : []; // 商圈等级(归属域商圈类型这个一级tab下的，并非是指另一个一级tab商圈等级)
      _params.businessDistrictLevels = businessDistrictLevels;

      /* 商圈标签 */
      const selfBrandTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.labelSystemSelfBrand] || [] : []; // 本品牌/门店覆盖
      const standardTaskTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.labelSystemStandardTask] || [] : []; // 拓店任务
      const standardChancePointTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.labelSystemStandardChancePoint] || [] : []; // 机会点
      const regionalProtectionTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.labelSystemRegionalProtection] || [] : []; // 区域保护
      const userCustomFlag = filter.shopsLayer ? handleUserCustomFlag(filter) : undefined; // 来源
      const planSpotTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.labelSystemPlanSpot] || [] : []; // 集客点
      const favoritesTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.labelSystemFavorites] || [] : []; // 标签：收藏
      const suitabilities = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.labelSystemSuitability] || [] : []; // 适合度
      const suitabilityFilter = filter.shopsLayer ? filter.newShopsCircle[sectionKey.suitabilityFilter] : null; // 是否合适
      _params.selfBrandTypes = selfBrandTypes;
      _params.standardTaskTypes = standardTaskTypes;
      _params.standardChancePointTypes = standardChancePointTypes;
      _params.regionalProtectionTypes = regionalProtectionTypes; // 区域保护
      _params.userCustomFlag = userCustomFlag;
      _params.planSpotTypes = planSpotTypes;
      _params.favoritesTypes = favoritesTypes;
      _params.suitabilities = suitabilities;
      _params.suitabilityFilter = suitabilityFilter;

      /* 商场特性 */
      const mallLevels = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.mallLevel] || [] : []; // 商场定位
      const mallSizes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.mallSize] || [] : []; // 商场规模
      const mallOpenYearsList = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.mallOpenYears] || [] : []; // 商场开业时长
      _params.mallLevels = mallLevels;
      _params.mallSizes = mallSizes;
      _params.mallOpenYearsList = mallOpenYearsList;

      /* 商场客流画像 */
      const mallPassFlowTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.passFlow] || [] : []; // 日均客流
      const genders = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.gender] || [] : []; // 性别
      const carProportions = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.carProportion] || [] : []; // 有车客群比例
      _params.mallPassFlowTypes = mallPassFlowTypes;
      _params.genders = genders;
      _params.carProportions = carProportions;

      /* 偏好品牌 */
      const preferBrandIds = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.preferBrand] || [] : [];
      _params.preferBrandIds = preferBrandIds;
      _params.shopOpenCloseTimeTypes = [
        ...(filter.newShopsCircle?.[sectionKey.shopOpenTimeTypes] || []),
        ...(filter.newShopsCircle?.[sectionKey.shopCloseTimeTypes] || []),
      ];

      /* 避开品牌 */
      const avoidBrandIds = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.avoidBrand] || [] : [];
      _params.avoidBrandIds = avoidBrandIds;

      /* 小区特性 */
      const householdsTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.households] || [] : []; // 小区户数
      const housePriceTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.housePrice] || [] : []; // 周边房屋均价
      const houseYearTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.houseYear] || [] : []; // 小区建筑年代
      _params.householdsTypes = householdsTypes;
      _params.housePriceTypes = housePriceTypes;
      _params.houseYearTypes = houseYearTypes;

      /* 居住人口 */
      const populationTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.population] || [] : []; // 500m人口聚集度
      const population3kmTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.population3km] || [] : []; // 3km人口聚集度
      _params.populationTypes = populationTypes;
      _params.population3kmTypes = population3kmTypes;

      /* 周边配套 */
      const workTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.workType] || [] : []; // 办公
      const schoolTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.schoolType] || [] : []; // 学校
      const trafficTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.trafficType] || [] : []; // 交通
      const scenicTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.scenicType] || [] : []; // 景区
      const medicalTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.medicalType] || [] : []; // 医院
      const otherTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.otherType] || [] : []; // 其他市场
      _params.workTypes = workTypes;
      _params.schoolTypes = schoolTypes;
      _params.trafficTypes = trafficTypes;
      _params.scenicTypes = scenicTypes;
      _params.medicalTypes = medicalTypes;
      _params.otherTypes = otherTypes;

      /* 市场评分 */
      const marketScoreTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.marketScore] || [] : [];
      _params.marketScoreTypes = marketScoreTypes;

      /* 餐饮门店 */
      const cateringStoreTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.cateringStore] || [] : []; // 门店数
      const oldCateringStoreTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.oldCateringStore] || [] : []; // 存续门店3年老店比例
      _params.cateringStoreTypes = cateringStoreTypes;
      _params.oldCateringStoreTypes = oldCateringStoreTypes;

      /* 收藏夹 */
      const favoriteIds = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.favorite] || [] : [];
      _params.favoriteIds = favoriteIds;
      /* 自定义标签 */
      const customLabelIds = Object.entries(filter.newShopsCircle)
        ?.filter(([k]) => k.startsWith(customLabelsPrefix))
        ?.map(([, v]) => isArray(v) ? v : [])
        ?.flat();
      _params.customLabelIds = customLabelIds;

    }

  }
  return _params;
};

export const heatDataMinZoom = 9;
export const heatDataMaxZoom = 18;


/**
 * !! 请勿轻易修改 top right bottom left
 * 根据当前位置的X，Y轴得到marker 的位置及offset
 * @param valueX 当前位置的X轴
 * @param valueY 当前位置的Y轴
 * @param mapClass 地图css
 * @param markerWidth marker的最大宽度
 * @param markerHeight marker的最大高度
 * @returns { anchor, offset }
 */
export const getMapMarkerAnchorOffsetByValueXY = (valueX, valueY, mapClass, markerWidth, markerHeight) => {
  const dom = document.querySelector(`.${mapClass}`);
  const offset = [40, -20];
  let topBottom = 'top';
  let leftRight = 'left';
  if (valueY < markerHeight) {
    topBottom = 'top';
    offset[1] = -20;
  } else if ((dom?.clientHeight || 0) - valueY < markerHeight) {
    topBottom = 'bottom';
    offset[1] = 10;
  }
  if (valueX < markerWidth) {
    leftRight = 'left';
    offset[0] = 40;
  } else if ((dom?.clientWidth || 0) - valueX < markerWidth) {
    leftRight = 'right';
    offset[0] = -40;
  }
  return {
    anchor: `${topBottom}-${leftRight}`,
    offset,
  };
};

/** 地图要素显示特殊列表标识 */
export const moreLayerSpecialListSigh = {
  /** 重点导入围栏 */
  'HIGHLIGHT_POLYGON': 1,
  /** 客群点位 */
  'POINT_AREA': 2,
};


export enum Dimension {
  Country = 'country', // 国省市-国
  Province = 'province', // 国省市-省
  City = 'city', // // 市
  CompanyAll = 'companyAll', // 分公司-国
  CompanyChild = 'companyChild', // 分公司-省
};

// 控制搜索返回的数据类型（不选则是全部）
export enum PoiSelection {
  Store = 1, // 门店
  GaodePoi = 2, // 高德poi
  BranchCompany = 3, // 分公司
  BigCircle = 4, // 市场容量/大圈
  Mall = 5, // 模型商圈/小圈/Mall
};


export const NATIONAL_ADCODE = 100000;

// 获取分公司数据中的score最大的值，如果isMaxVal传false，则返回score最大的那一项
export const getMaxCount = (arr: any[], isMaxVal = true, targetField = 'score') => {
  // 初始化最大值为数组第一个元素的count
  let maxTarget = arr[0];
  let max = maxTarget?.[targetField];

  // 遍历数组，更新最大值
  for (let i = 1; i < arr.length; i++) {
    const currentCount = arr[i]?.[targetField];
    if (currentCount > max) {
      max = currentCount;
      maxTarget = arr[i];
    }
  }

  return isMaxVal ? max : maxTarget;
};

// 大兴安岭飞地的特殊处理，重置经纬度
export const daXingAnLingCityId = 72;
export const daXingAnLingLngLat = {
  lng: 124.709701,
  lat: 52.334446
};

// 检查鼠标是否在地图上
export const handleNotMapHover = (event) => {
  const isMapHovering = event?.target?.closest?.(`.amap-maps`) !== null; // 检查鼠标是否在某个元素或其子元素上
  return isMapHovering;
};

// 处理特殊的城市code，结合area/list接口，特殊的几个直辖市需要传父级的code才能渲染出来，但是分公司接口数据返回的是子级的code
export const handleAddCode = (codes: string[], targetCode: string, isProvinceCQ = false) => {
  // 重庆市&重庆郊县
  if (isProvinceCQ && [CQ_CODE_CITY, CQ_CODE_SUBURB].includes(targetCode)) {
    codes.push('500000');
  } else if (targetCode === '110100') { // 北京
    codes.push('110000');
  } else if (targetCode === '120100') { // 天津
    codes.push('120000');
  } else if (targetCode === '310100') { // 上海
    codes.push('310000');
  } else {
    targetCode && codes.push(targetCode);
  }
  return codes;
};

export const companyLayerhoverColor = '#FFA31D';

// 销售品类枚举值
export enum ShopSalesTypeValue {
  'XTC' = 1,
  'BBK',
  'XTC_BBK', // 全部
}

/**
 * 将数组中满足条件的项放到最后
 * @param {Array} arr - 原数组
 * @param {Function} condition - 判断是否为目标项的函数
 * @returns {Array} 新数组（原数组不变）
 */
export const moveItemsToEnd = (arr, condition) => {
  const nonTargetItems = arr.filter(item => !condition(item));
  const targetItems = arr.filter(item => condition(item));
  return [...nonTargetItems, ...targetItems];
};

/** 跳转页面的uri */
export const enum MenuUri {
  ChancePoint = '/expandstore/chancepoint',
  Shop = '/expandstore/shop',
  Spotsurvey = '/expandstore/spotsurvey',
}

/** 竞品品牌门店功能类型筛选启用开关 */
export enum BrandShopFunctionFilter {
  OFF = 1,
  ON = 2,
}

export const selfBrandSelectionsExcludeCode = ['typeName', 'statusName'];

export enum YouthMapModuleCode {
  SHOP_MODULE = 1, // 门店情况
  CITY_MODULE = 2, // 城市信息
  INSURANCE_MODULE = 3, // 上险量
  BRAND_MODULE = 4, // 关注品牌&品牌门店走势
  PLAN_MODULE = 5, // 规划看板
  MARKET_CAPACITY = 6, // 市场容量
};

/** 管理片区可操作围栏类型枚举 */
export enum ManageAreaOperableFenceEnum {
  /** 已选中 */
  Selected = 'selected',
  /** 商圈 */
  BusinessCircle = 'businessCircle',
  /** 空地 */
  Borderlands = 'borderlands',
  /** 不可选 */
  Disabled = 'disabled',
}

// 管理片区操作时的围栏的样式
export const manageAreaInOperationPolygonOption = {
  [ManageAreaOperableFenceEnum.Selected]: {
    strokeColor: '#FFA31D',
    strokeWeight: 1, // 轮廓线宽度
    strokeOpacity: 1, // 轮廓线透明度
    fillColor: '#FFA31D', // 多边形填充颜色，
    fillOpacity: 0.24, // 多边形填充透明度
  },
  [ManageAreaOperableFenceEnum.BusinessCircle]: {
    strokeColor: '#459CFF',
    strokeWeight: 1, // 轮廓线宽度
    strokeOpacity: 1, // 轮廓线透明度
    fillColor: '#459CFF', // 多边形填充颜色，
    fillOpacity: 0.24, // 多边形填充透明度
  },
  [ManageAreaOperableFenceEnum.Borderlands]: {
    strokeColor: '#C496FF',
    strokeWeight: 1, // 轮廓线宽度
    strokeOpacity: 1, // 轮廓线透明度
    fillColor: '#C496FF', // 多边形填充颜色，
    fillOpacity: 0.24, // 多边形填充透明度
  },
  [ManageAreaOperableFenceEnum.Disabled]: {
    strokeColor: '#999999',
    strokeWeight: 1, // 轮廓线宽度
    strokeOpacity: 1, // 轮廓线透明度
    fillColor: '#999999', // 多边形填充颜色，
    fillOpacity: 0.24, // 多边形填充透明度
  },
};
